import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCarousel, { EcoSectionCarouselItemProps } from 'eco-design/sections/eco-section-carousel';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.ListA1');
    const itemsA: EcoSectionCarouselItemProps[] = [
        {
            desc: '',
            icon: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745206135834/1927.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745206135834/1927.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745206412298/1.jpg',
            title: t('item1_title'),
        },
        {
            desc: '',
            icon: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745206136127/Rectangle%2050788.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745206136127/Rectangle%2050788.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745206413505/2.jpg',
            title: t('item2_title'),
        },
        {
            desc: '',
            icon: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745206136544/Rectangle%2050787.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745206136544/Rectangle%2050787.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745206413238/3.jpg',
            title: t('item3_title'),
        },
        {
            desc: '',
            icon: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745206137042/Rectangle%2050785.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745206137042/Rectangle%2050785.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745206412953/4.jpg',
            title: t('item4_title'),
        },
        {
            desc: '',
            icon: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745206136662/Rectangle%2050786.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745206136662/Rectangle%2050786.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745206412725/5.jpg',
            title: t('item5_title'),
        },
        {
            desc: '',
            icon: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745206135506/Rectangle%2050785%20(1).jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745206135506/Rectangle%2050785%20(1).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745206412384/6.jpg',
            title: t('item6_title'),
        },
    ];
    return (
        <div className={`${styles.comp}`}>
            <EcoSpace />
            <EcoSectionCarousel title={t('title')} headerLayout="header-bottom" items={itemsA} />
        </div>
    );
}
